import { Component, OnInit } from '@angular/core';

//import { PatientPortalService } from '../patient-portal/patient-portal.service';
import { ARService } from '../ar/ar.service';
import { MessagingService } from '../../services/messaging.service';
import { PatientPortalService } from '../patient-portal/patient-portal.service';

@Component({
  standalone: false,
  selector: 'app-check-in',
  templateUrl: './check-in.component.html',
  styleUrls: ['./check-in.component.css']
})
export class CheckInComponent implements OnInit {

  enableScanner: boolean = false;
  activeDevice: any = {
    deviceId: '',
    groupId: '',
    kind: '',
    label: ''
  };
  activeDevices: any[] = [];
  showSuccess: boolean = false;
  isLoading: boolean = false;
  successTimeout: any;
  enumCheckedInStatus: string = '00000072-0000-0000-0000-000000000003';

  constructor(
    private infoService: PatientPortalService,
    private arService: ARService,
    private messagingService: MessagingService,
  ) { }

  ngOnInit() {
  }

  scanSuccessHandler(payload: string) {
    console.log('scanSuccessHandler', payload);

    var payloadParts = payload.split('/');

    var patientId = payloadParts[0];
    var appointmentId = payloadParts[1];

    this.processDetails(patientId, appointmentId);
  }

  test() {
    var payload = 'f0f6903f-f29e-e711-a59f-6045cb81d461/a0d83591-edba-ea11-b2a1-001195500624';

    var payloadParts = payload.split('/');
    var patientId = payloadParts[0];
    var appointmentId = payloadParts[1];

    var notificationMessage = `Patient TEST has checked-in for their TEST appointment.`;
    this.messagingService.sendComponentMessage("SOCKET_NOTIFICATION", { message: notificationMessage });

    //this.processDetails(patientId, appointmentId);
  }

  processDetails(patientId: string, appointmentId: string) {

    let promises = [
      this.getPatientInformation(patientId),
      this.getAppointmentInformation(appointmentId),
      this.checkInAppointment(appointmentId),
    ];

    this.isLoading = true;
    Promise.all(promises).then((results: any[]) => {

      var patientInfo = results[0];
      var appointmentInfo = results[1];

      var patientName = '';

      if (patientInfo.dataContact.FirstName) {
        patientName += patientInfo.dataContact.FirstName + ' ';
      }

      if (patientInfo.dataContact.LastName) {
        patientName += patientInfo.dataContact.LastName;
      }

      var appointmentDate = new Date(appointmentInfo.StartDate);
      var appointmentName = `${this.getFormatedTime(appointmentDate.getHours(), appointmentDate.getMinutes())}`;

      //if (appointmentInfo.dataDoctor4Info && appointmentInfo.dataDoctor4Info.dataContact) {
      //  appointmentName = `${appointmentName} with Dr. ${appointmentInfo.dataDoctor4Info.dataContact.LastName}`;
      //}

      var notificationMessage = `Patient ${patientName} has checked-in for their ${appointmentName} appointment.`;
      this.messagingService.sendSocketMessage("SOCKET_NOTIFICATION", { message: notificationMessage });

      this.showSuccess = true;

      if (this.successTimeout) {
        clearTimeout(this.successTimeout);
        this.successTimeout = false;
      }

      this.successTimeout = setTimeout(_ => {
        this.showSuccess = false;
        this.successTimeout = false;
      }, 3000);


      this.isLoading = false;
    }, err => {
      console.log('err', err);
      this.isLoading = false;
    });
  }

  checkInAppointment(appointmentId: string) {
    let promise = new Promise((resolve, reject) => {
      this.infoService.setAppointmentStatus(appointmentId, this.enumCheckedInStatus)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  getPatientInformation(patientId: string) {
    let promise = new Promise((resolve, reject) => {
      this.arService.getPatientAndContact(patientId)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  getAppointmentInformation(appointmentId: string) {
    let promise = new Promise((resolve, reject) => {
      this.infoService.getAppointmentInformation(appointmentId)
        .subscribe(resolve, reject);
    });
    return promise;
  }

  getFormatedTime(hour: number, minutes: number) {

    var timePeriod = 'am';
    if (hour >= 12) {
      timePeriod = 'pm';
    }

    if (hour > 12) {
      hour = hour - 12;
    }

    var newMinutes = ''

    if (minutes < 10) {
      newMinutes = `0${minutes}`;
    } else {
      newMinutes = `${minutes}`;
    }

    return `${hour}:${newMinutes}${timePeriod}`
  }

  returnDatFormated(day: number) {
    if (day > 3 && day < 21) return `${day}th`;
    switch (day % 10) {
      case 1: return `${day}st`;
      case 2: return `${day}nd`;
      case 3: return `${day}rd`;
      default: return `${day}th`;
    }
  }

  returnShortMonth(monthIndex: number) {
    var monthArr = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
    return monthArr[monthIndex];
  }

  camerasFoundHandler(payload) {
    console.log('CAMERA FOUND', payload);
    this.activeDevices = payload;
    if (this.activeDevices.length !== 0) {
      this.activeDevice = this.activeDevices[0];
      this.enableScanner = true;
    } else {
      // could not find camera
    }
  }

  selectedDevice() {
    this.enableScanner = true;
  }

}
